import React, {Component} from 'react';
import Highcharts from 'highcharts';

export class Charts extends Component {

    componentDidMount() {
        this.chart = new Highcharts['Chart'](this.refs.chart, this.props.options);
    }

    componentWillReceiveProps(nextProps) {
        this.chart = new Highcharts['Chart'](this.refs.chart, this.props.options);
    }

    render() {
        return <div ref='chart'></div>
    };

};

export default Charts;


// WEBPACK FOOTER //
// ./src/containers/Charts/Charts.js